import classNames from "classnames";
import {HTMLAttributes, PropsWithChildren} from "react";

export const Badge = ({color, children, className, ...rest}: {
  color?: string
} & PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return <div {...rest}
              className={classNames(`border p-1 pr-2 pl-2 rounded-xl inline-block ml-2 mr-2 text-sm `, className)}>{children}</div>
}

export const BadgeDot = ({color, children, className, ...rest}: {
  color?: string
} & PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return <div {...rest} className={classNames(`p-1 pr-2 pl-2 inline-block m-2 text-sm `, className)}>• {children}</div>
}